import { VendorInvoicesService } from "src/services/documents/VendorInvoicesService";
import { IAppEntity } from "src/config/entities";
import React from "react";
import { DocumentService } from "../../../services/documents/DocumentService";
import { ReferenceTypes } from "src/enums/ReferenceTypes";
import { ICreateVendorInvoicesDto } from "src/dtos/documents/VendorInvoices/ICreateVendorInvoicesDto";
import { NFLookupVendorInvoice } from "src/components/Shared/NewForms/NFLookupVendorInvoice";
import {
  VendorInvoicesDetail
} from "src/components/Pages/Documents/Purchases/VendorInvoices/components/VendorInvoicesDetail";
import VendorInvoicesList
  from "src/components/Pages/Documents/Purchases/VendorInvoices/components/VendorInvoicesList";

export const VendorInvoices: IAppEntity = {
  entityType: "document",
  title: "Vendor Invoices",
  pluralTitle: "Vendor Invoices",
  apiUrl: "VendorInvoices",
  apiEnum: ReferenceTypes.DocumentVendorInvoice,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(VendorInvoicesDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(VendorInvoicesList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupVendorInvoice, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new VendorInvoicesService("VendorInvoices"),
  getEmptyModel: () => {
    const model: ICreateVendorInvoicesDto = {
      priceIncludesVat: false,
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      createdDate: new Date(),
      documentDate: new Date(),
      products: [],
      services: [],
      paymentOffsets: [],
    };
    return model;
  },
};
